import {useSelector} from "react-redux";
import {allMessages} from "../../redux/selectors/messages";

export const useMessages = (id)=>{
    const messages = useSelector(allMessages);
    return messages.filter(x => Number(x.chat_id) === Number(id));
}
